window.Products.Clothing.YouthLeggings8to9years = function() {};

window.Products.Clothing.YouthLeggings8to9years.inherits(window.Products.Clothing.YouthLeggings);
window.Products.Clothing.YouthLeggings8to9years.has_3d = true;
window.Products.Clothing.YouthLeggings8to9years.id = '60-8to9years';
window.Products.Clothing.YouthLeggings8to9years.saveId = 60;
window.Products.Clothing.YouthLeggings8to9years.slug = 'youth-leggings-8to9years';
window.Products.Clothing.YouthLeggings8to9years.dpi = 150;